import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { FswService } from '@services/fsw.service';
import { AuthService } from '@services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  userForm!: FormGroup;
  id!: any;
  isReadMode: boolean = true;
  loading = false;
  submitted = false;
  StateRecord: any[] | undefined;
  selectedState: any = null;
  success = false;
  userName: any;
  userRecord!: any[];

  public imagePath: any;
  imgURL: any;
  public message!: string;

  constructor(private formBuilder: FormBuilder, private router: Router, private userService: FswService, private authService: AuthService, private spinnerService: NgxSpinnerService
    // , private alertService: AlertService
  ) { }

  ngOnInit() {

    this.spinnerService.show();
    this.userForm = this.formBuilder.group({
      userName: ['', Validators.required],
      stateCode: ['', Validators.required],
      userId: [''],
      password: [''],
      roles: [''],
      emailId: ['', Validators.required],
      mobileNo: ['', Validators.required],
      designation: ['', Validators.required]
      // mobileNo: ['', [Validators.required, Validators.pattern("^[0-9]{10}$")]]
    });

    this.userName = this.authService.getUserName();
    this.userService.getUserDetails(this.userName)
      .subscribe(res => {
        debugger
        this.userRecord = res;
        this.spinnerService.hide();
      });
  }
  get f(): { [key: string]: AbstractControl } {
    return this.userForm.controls;
  }
  getState() {
    debugger
    this.spinnerService.show();
    this.userService.getState().subscribe(
      (Statedata) => {
        this.StateRecord = Statedata;
        console.log(this.StateRecord);
        this.spinnerService.hide();
      }
    )
  }


  onupdateProfileSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    this.goToProfile();

    this.router.navigate(['/view-profile']);
    
    debugger
    if (this.userForm.invalid) {
      return;
    }

    else{
      this.router.navigate(['/view-profile']);
      window.location.reload();
    }
    //var role = ["ROLE_USER"]
  //  var vehicleNo = this.userForm.get('vehicleNo')?.value;
    //const replacedvehicleNo = vehicleNo.replaceAll('-', '')
    //this.addVehicleForm.controls['password'].setValue('Fssai@1');
    //this.addVehicleForm.controls['userId'].setValue(replacedvehicleNo);
  //  this.userForm.controls['vehicleNo'].setValue(vehicleNo);
    //this.addVehicleForm.controls['roles'].setValue(role);


    console.log(this.userForm.value);
    this.userService.updateProfileData(this.id, this.userForm.value)
      .subscribe(
        response => {
          this.submitted = true;
          this.spinnerService.hide();
          this.isReadMode = true;
        },
        error => {
          console.log(error);
          this.spinnerService.hide();
        });
        this.isReadMode = true;
    this.success = true;
 //   this.userForm.reset({});
  }
  goToProfile(){
    this.router.navigate(['/view-profile']);
    
  }
  
  closeAlert() {
    this.success = false;
  }
  changeView() {
    if (this.isReadMode == true) {
      this.isReadMode = false;
      this.getState();
      this.id = this.userRecord[0].id;
      this.selectedState = this.userRecord[0].stateCode;
      this.userForm.controls['userName'].setValue(this.userRecord[0].userName);
      this.userForm.controls['stateCode'].setValue(this.userRecord[0].stateCode);
      this.userForm.controls['designation'].setValue(this.userRecord[0].designation);
      this.userForm.controls['emailId'].setValue(this.userRecord[0].emailId);
      this.userForm.controls['mobileNo'].setValue(this.userRecord[0].mobileNo);
      this.userForm.controls['password'].setValue(this.userRecord[0].password);
      this.userForm.controls['userId'].setValue(this.userRecord[0].userId);
    //  this.userForm.controls['city'].setValue(this.userRecord[0].city);
this.goToProfile();
    }
    else {
      this.isReadMode = true;
      this.goToProfile();
      
    }
  }
  
  preview(files: string | any[]) {
    if (files.length === 0)
      return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    }
  }
  onFileSelect(event: any) {
    debugger
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file) {
        if (file.type == "application/pdf" || file.type == "image/jpeg") {
          debugger
          if (file.size < 10485760) {
            debugger
            const reader: FileReader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              this.imgURL = reader.result;
            };
          }
          else {
            alert("File should be in 10 mb.");
            return;
          }
        }
        else {
          alert("File Type should be in pdf or jpg format.");
          return;
        }

      }
    }
  }
}

